import { Buffer } from 'buffer'

import { fetch as expoFetch } from 'expo/fetch'
import { File as ExpoFile } from 'expo-file-system'
import SparkMD5 from 'spark-md5'

import Base64 from 'app/utils/helpers/base64.helpers'

import { IS_NATIVE_APP } from '../constants/env.constants'

const fileChecksumWeb = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const md5Buffer = new SparkMD5.ArrayBuffer()
    const fileReader = new FileReader()

    fileReader.readAsArrayBuffer(file)

    fileReader.addEventListener('load', (event) => {
      md5Buffer.append(event?.target?.result)

      const binaryDigest = md5Buffer.end(true)
      const base64digest = Base64.btoa(binaryDigest)

      resolve(base64digest)
    })

    fileReader.addEventListener('error', (event) => reject(event))
  })
}

const fileChecksumApp = (uri: string): Promise<string> => {
  return new Promise(async (resolve, _reject) => {
    const md5Buffer = new SparkMD5.ArrayBuffer()

    const result = await new ExpoFile(uri).base64()

    const binaryImage = Buffer.from(result, 'base64')

    md5Buffer.append(binaryImage)

    const binaryDigest = md5Buffer.end(true)
    const base64digest = Base64.btoa(binaryDigest)

    resolve(base64digest)
  })
}

export const getFilePayload = async ({
  file,
  uri
}: {
  file: File
  uri: string
}): Promise<{
  name: string
  size: number
  type: string
  checksum: string
}> => {
  const payload = {
    name: file.name || 'image',
    size: file.size || 0,
    type: file.type || 'application/octet-stream'
  }

  if (!IS_NATIVE_APP) {
    const checksum = await fileChecksumWeb(file)

    return { ...payload, checksum }
  } else {
    const checksum = await fileChecksumApp(uri)

    return { ...payload, checksum }
  }
}

interface PutUploadFileProps {
  url: string
  uri: string
  file: File
  headers: Record<string, string>
}

export const putUploadFile = async ({
  url,
  uri,
  file,
  headers
}: PutUploadFileProps) => {
  if (!IS_NATIVE_APP) {
    const axios = await import('axios')

    return axios.default.put(url, file, { headers })
  } else {
    const bytes = await new ExpoFile(uri).bytes()

    return expoFetch(url, { method: 'PUT', body: bytes, headers })
  }
}
